
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSSalesReceiptDetailsGrid extends Serenity.EntityGrid<POSSalesReceiptDetailsRow, any> {
        protected getColumnsKey() { return 'Retail.POSSalesReceiptDetails'; }
        protected getDialogType() { return POSSalesReceiptDetailsDialog; }
        protected getIdProperty() { return POSSalesReceiptDetailsRow.idProperty; }
        protected getInsertPermission() { return POSSalesReceiptDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return POSSalesReceiptDetailsRow.localTextPrefix; }
        protected getService() { return POSSalesReceiptDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}